import getUrlPath from '../../utils/getUrlPath';
import { AreaTwo, ExternalIcon, Link, LinkIcon, Links, MenuTitle } from './Style';
import { FormattedMessage } from 'react-intl';
import { url } from '../../constants/url';

function FleetMenuLinks() {
  return (
    <AreaTwo>
      <Links>
        <MenuTitle>
          <FormattedMessage id={'userDropdown.subtitles.t3Tech'} />
        </MenuTitle>
        <Link
          href={getUrlPath(url.estrack.subPath.t3Fleet.id)}
          target='_blank'
        >
          <FormattedMessage id={'userDropdown.links.fleetMap'} />
          <LinkIcon>
            <ExternalIcon />
          </LinkIcon>
        </Link>
      </Links>
    </AreaTwo>
  );
}

export default FleetMenuLinks;
